import { useEffect, useState } from 'react';
import { Highlight } from '@mantine/core';
import {
  IConsultationOutcome,
  IConsultationSubOutcome,
} from '../../hooks/promises/getConsultationOutcomes';
import { Dropdown } from '../Dropdown/Dropdown';

export interface ICheckboxDropdownProps {
  displayedOutcome: IConsultationOutcome;
  isChecked: boolean;
  disabled: boolean;
  defaultSubOutcome: IConsultationSubOutcome;
  userSearchString: string;
  onClick?: (val: boolean) => void;
  addSubOutcome?: (val: IConsultationSubOutcome | undefined | null) => void;
}

export function CheckboxDropdown({
  displayedOutcome,
  disabled,
  isChecked,
  defaultSubOutcome,
  userSearchString,
  onClick,
  addSubOutcome,
}: ICheckboxDropdownProps) {
  const [checked, setChecked] = useState<boolean>(false);
  const [selectedSubOutcome, setSelectedSubOutcome] =
    useState<IConsultationSubOutcome | null>(defaultSubOutcome);
  useEffect(() => setChecked(isChecked), []);

  useEffect(() => {
    if (isChecked && addSubOutcome) {
      addSubOutcome(selectedSubOutcome);
    }
  }, [isChecked, selectedSubOutcome]);

  let body;

  if (addSubOutcome && checked)
    body = (
      <Dropdown
        items={displayedOutcome.subOutcomes}
        getItemId={(subOutcome) =>
          subOutcome.consultationSubOutcomeId.toString()
        }
        getItemValue={(subOutcome) =>
          subOutcome.consultationSubOutcomeDescriptionShort
        }
        selectedItem={selectedSubOutcome}
        setSelectedItem={(subOutcome) => {
          setSelectedSubOutcome(subOutcome);
          addSubOutcome(subOutcome);
        }}
        size="md"
        label={displayedOutcome.consultationOutcomeDescriptionShort}
      />
    );
  else
    body = (
      <Highlight
        highlight={userSearchString}
        className={`leading-6 text-[1.1rem] select-none ${
          checked ? 'font-semibold text-primary-500' : ''
        }${disabled ? 'text-gray-400 cursor-not-allowed' : 'cursor-pointer'}`}
        onClickCapture={() => {
          if (onClick) onClick(!checked);
          setChecked((c) => !(disabled || c));
        }}
      >
        {displayedOutcome.consultationOutcomeDescriptionShort}
      </Highlight>
    );

  return (
    <div className="flex flex-row items-start gap-1">
      <input
        type="checkbox"
        id={displayedOutcome.consultationOutcomeDescription}
        checked={checked}
        disabled={disabled && !checked}
        onChange={() => {
          if (onClick) onClick(!checked);
          setChecked((x: boolean) => !x);
        }}
        className={`mr-2 ${
          disabled ? 'cursor-not-allowed' : 'cursor-pointer'
        } transform scale-[1.2] translate-y-1.5`}
      />
      {body}
    </div>
  );
}
